<template>
  <div>
    <h1>Connect to Miro</h1>
    <p v-if="isConnected">You are connected to Miro!</p>
    <p v-else-if="errorMessage">{{ errorMessage }}</p>
    <p v-else>This is the Connect to Miro page.</p>
    <button v-if="!isConnected" @click="handleMiroLogin">Connect to Miro</button>
    <button v-if="isConnected" @click="handleDisconnect">Disconnect from Miro</button>
    <div v-if="fullResponse">
      <h2>Miro Response:</h2>
      <pre>{{ fullResponse }}</pre>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConnectToMiroPage',
  data() {
    return {
      clientId: process.env.VUE_APP_MIRO_CLIENT_ID, // Use environment variable
      redirectUri: process.env.VUE_APP_MIRO_REDIRECT_URI, // Use environment variable
      authCode: null,
      isConnected: false,
      errorMessage: null,
      fullResponse: null, // Add a data property to store the full response
    };
  },
  methods: {
    handleMiroLogin() {
      // Redirect the user to the Miro OAuth authorization URL
      window.location.href = `https://miro.com/oauth/authorize?response_type=code&client_id=${this.clientId}&redirect_uri=${this.redirectUri}`;
    },
    async getAccessToken() {
      // Define the request URL for the backend endpoint to exchange the authorization code for an access token
      // const requestUrl = "http://localhost:8000/auth-token";
      const requestUrl = `${process.env.VUE_APP_API_URL}/auth-token`;

      // Prepare the request body with the necessary parameters
      const body = {
        client_id: this.clientId,
        code: this.authCode,
        redirect_uri: this.redirectUri
      };

      // Make a POST request to the backend to exchange the authorization code for an access token
      try {
        const response = await fetch(requestUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(body)
        });

        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(`Error: ${response.status} ${response.statusText} - ${errorData.detail}`);
        }

        const result = await response.json();
        this.fullResponse = result; // Store the full response
        localStorage.setItem("miro_response", JSON.stringify(result)); // Save the full response in localStorage
        if (result.access_token) {
          // Store the access token in localStorage
          localStorage.setItem("access_token", result.access_token);
          console.log('Access token obtained:', result.access_token);
          this.isConnected = true; // Set the connected status
        } else {
          console.error('Error obtaining access token:', result);
          this.errorMessage = 'Failed to obtain access token from Miro.';
        }
      } catch (e) {
        console.error('Error obtaining access token', e);
        this.errorMessage = `Error occurred while trying to connect to Miro: ${e.message}`;
      }
    },
    handleDisconnect() {
      // Clear the stored authentication details from localStorage
      localStorage.removeItem("miro_response");
      localStorage.removeItem("access_token");
      this.fullResponse = null;
      this.isConnected = false;
      this.errorMessage = null;
    }
  },
  beforeMount() {
    const urlParams = new URLSearchParams(window.location.search);
    this.authCode = urlParams.get('code');

    const savedResponse = localStorage.getItem("miro_response");
    if (savedResponse) {
      this.fullResponse = JSON.parse(savedResponse);
      this.isConnected = true; // Set the connected status if access token is already stored
    } else if (this.authCode) {
      this.getAccessToken();
    }
  }
};
</script>

<style scoped>
h1 {
  color: #42b983;
}
</style>
